export interface GenericApiResponse<T> {
  status: 'OK' | 'ERROR'
  errorCode: string
  message: string
  payload: T
}

export interface ApiCommonResponse {
  status?: 'OK' | 'ERROR'
  errorCode?: string
  message?: string
  payload?: any
}

export enum MediaTypes {
  LIVE_CHANNEL = 'LIVE_CHANNEL',
  VIDEO = 'VIDEO',
  TV_SHOW = 'TV_SHOW',
}
